import logoInstitucion from '../../assets/logo.png';
import { fechaHoraActualBoliviaSoloVista} from '../../util/valueCalculator';


export const addHeader = ({
    doc,
    pageNumber,
    headerHeight,
    marginLeftRight,
    marginTop,
    fontSize = 16, // Tamaño de la fuente para el texto principal
    imageScaleFactor = 1, // Factor de escala para la imagen
    textOffsetX = 15, // Desplazamiento horizontal del texto respecto a la imagen
    textOffsetY = 0, // Desplazamiento vertical del texto respecto a la imagen
    showPageNumber = true, // Mostrar número de página
    pageNumberFontSize = 12 // Tamaño de la fuente para el número de página
}) => {
    const pageWidth = doc.internal.pageSize.getWidth();

    // Obtener las propiedades de la imagen
    const imgProps = doc.getImageProperties(logoInstitucion);
    const imgWidth = imgProps.width;
    const imgHeight = imgProps.height;

    // Calcular el tamaño de la imagen
    const maxDimension = headerHeight * imageScaleFactor; // Escalar la imagen según el factor
    const scale = maxDimension / Math.max(imgWidth, imgHeight); // Escalar proporcionalmente
    const scaledWidth = imgWidth * scale;
    const scaledHeight = imgHeight * scale;

    // Dibujar la imagen alineada a la izquierda
    doc.addImage(
        logoInstitucion,
        'PNG',
        marginLeftRight, // Posición horizontal (alineada a la izquierda)
        marginTop, // Posición vertical
        scaledWidth,
        scaledHeight
    );

    // Agregar el texto principal a la derecha de la imagen
    doc.setFontSize(fontSize);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0); // Texto negro
    doc.text(
        "COLEGIO DE ARQUITECTOS TARIJA",
        marginLeftRight + scaledWidth + textOffsetX, // Posición horizontal
        marginTop + scaledHeight / 2 + textOffsetY, // Centrar verticalmente con respecto a la imagen
        { align: 'left' }
    );
    doc.setFont("times", "normal");
    // Agregar el número de página si está habilitado
    if (showPageNumber && pageNumber > 0) {
        doc.setFontSize(pageNumberFontSize);
        doc.text(
            `Página ${pageNumber}`,
            pageWidth - marginLeftRight, // Alinear al margen derecho
            marginTop + headerHeight + textOffsetY, // Posición vertical
            { align: 'right' }
        );
    }
};

export const addFooter = ({doc,marginLeftRight, marginBottom,nombre}) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setDrawColor(0, 50, 0); // Verde más oscuro
    doc.setLineWidth(1);
    doc.line(marginLeftRight, pageHeight - marginBottom - 10, pageWidth - marginLeftRight, pageHeight - marginBottom - 10);

    doc.setFontSize(12);
    doc.setTextColor(0, 50, 0); // Verde más oscuro
    doc.setFont("times", "normal");
    doc.text('Calle La Madrid # 615 casi Esq. Junín - Celular.: (591-4)6640066 - cat.tarija@gmail.com', pageWidth / 2, pageHeight - marginBottom + 20, { align: 'center' });
    doc.text('Tarija - Bolivia', pageWidth / 2, pageHeight - marginBottom + 30, { align: 'center' });
    doc.setFontSize(10);
    doc.text(
        `Impreso el: ${fechaHoraActualBoliviaSoloVista()} | Usuario: ${nombre}`, 
        pageWidth - marginLeftRight, 
        pageHeight - marginBottom + 40, 
        { align: 'right' }
    );
};

export const addWatermark = (doc) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();

    doc.setFontSize(72);
    doc.setTextColor(240, 240, 240); // marca de agua
    doc.setFont("helvetica", "bold");
    doc.text("COPIA", pageWidth / 2, pageHeight / 2, {
        angle: 45,
        align: 'center'
    });
};

export const addTitles = ({
    doc, 
    titles, 
    margins, 
    headerHeight,  
    fontSize1=16,
    textOffsetY=14,
    fontSize2=12}) => 
    {
        doc.setFontSize(fontSize1);
        doc.setFont("times", "bold");
        doc.setTextColor(0, 0, 0); // Asegurar que los títulos estén en negro
        const {marginTop, marginLeftRight} = margins;
        const {validTitle1, validTitle2, validTitle3, validTitle4, validTitle5,validTitle6,validTitle7} = titles;
        let currentY = marginTop + headerHeight + textOffsetY; // Posición inicial vertical

        // Validar que los títulos no sean nulos o vacíos
        if (validTitle1) {
            const title1Lines = doc.splitTextToSize(validTitle1, doc.internal.pageSize.getWidth() - 2 * marginLeftRight);
            doc.text(title1Lines, doc.internal.pageSize.getWidth() / 2, currentY, { align: 'center' });
            currentY += title1Lines.length * textOffsetY; // Ajustar la posición vertical según el número de líneas
        }

        doc.setFontSize(fontSize2);
        doc.setFont("times", "normal");
        currentY+=textOffsetY; // Espacio adicional antes de los siguientes títulos
        const addTitleLine = (title, yOffset) => {
            if (title) {
                const titleLines = doc.splitTextToSize(title, doc.internal.pageSize.getWidth() - 2 * marginLeftRight);
                doc.text(titleLines, marginLeftRight, currentY, { align: 'left' });
                currentY += titleLines.length * yOffset; // Ajustar la posición vertical según el número de líneas
            }
        };

        addTitleLine(validTitle2, textOffsetY); // Altura de línea para títulos normales
        addTitleLine(validTitle3, textOffsetY);
        addTitleLine(validTitle4, textOffsetY);
        addTitleLine(validTitle5, textOffsetY);
        addTitleLine(validTitle6, textOffsetY);
        addTitleLine(validTitle7, textOffsetY);

        return currentY; // Retornar la posición final de los títulos
};